import { WithModal } from 'hocs/withModal';

import { ListQualityRequirementTemplate } from './List';
import { DetailQualityRequirementTemplate } from './Detail';
import { SaveAsNewTemplate } from './SaveAsNewTemplate';

const ModalListQualityRequirementTemplate = WithModal(ListQualityRequirementTemplate);
const ModalDetailQualityRequirementTemplate = WithModal(DetailQualityRequirementTemplate);
const ModalSaveAsNewTemplate = WithModal(SaveAsNewTemplate);

export {
  ModalListQualityRequirementTemplate,
  ListQualityRequirementTemplate,
  ModalDetailQualityRequirementTemplate,
  DetailQualityRequirementTemplate,
  ModalSaveAsNewTemplate,
  SaveAsNewTemplate,
};
